(function () {
  document.querySelectorAll('[data-fph]').forEach(function (section) {
    var variantData = JSON.parse(section.querySelector('[data-fph-variants]').textContent);
    var pills       = section.querySelectorAll('.fph-pill');
    var idInput     = section.querySelector('.fph-id-input');
    var priceEl     = section.querySelector('.fph-price');
    var atcBtn      = section.querySelector('.fph-atc');
    var selected    = {};

    function findVariant() {
      return variantData.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected['option' + (i + 1)] === opt;
        });
      }) || null;
    }

    function updateUI() {
      var v = findVariant();
      if (v) {
        idInput.value = v.id;
        var price = (v.price / 100).toFixed(2);
        var compare = v.compare_at_price ? (v.compare_at_price / 100).toFixed(2) : null;
        priceEl.innerHTML = compare
          ? '<s>' + section.dataset.currencySymbol + compare + '</s>' + section.dataset.currencySymbol + price
          : section.dataset.currencySymbol + price;
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? atcBtn.dataset.labelAdd : atcBtn.dataset.labelSold;
      } else {
        atcBtn.disabled = true;
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var opt  = pill.dataset.option;
        var val  = pill.dataset.value;
        selected[opt] = val;

        section.querySelectorAll('.fph-pill[data-option="' + opt + '"]').forEach(function (p) {
          p.classList.toggle('is-selected', p.dataset.value === val);
        });
        updateUI();
      });
    });

    /* seed first available variant */
    var first = variantData.find(function (v) { return v.available; }) || variantData[0];
    if (first) {
      first.options.forEach(function (val, i) {
        selected['option' + (i + 1)] = val;
        var pill = section.querySelector('.fph-pill[data-option="option' + (i + 1) + '"][data-value="' + CSS.escape(val) + '"]');
        if (pill) pill.classList.add('is-selected');
      });
      idInput.value = first.id;
    }
  });
})();
